module.exports = "<svg viewBox=\"0 0 13.6 11.6\"><path fill=\"#231F20\" d=\"M.7 6.5h4.6L6.7.8c.1-.4-.2-.8-.6-.8H2c-.3 0-.6.2-.7.5L0 5.7c-.1.4.2.8.7.8zm6.9 0h4.6L13.6.8c.1-.4-.2-.8-.6-.8H8.9c-.4 0-.6.2-.7.5L6.9 5.7c-.1.4.2.8.7.8z\"></path><path fill=\"#231F20\" d=\"M3.3 11.6c.4 0 .8-.3.9-.7L6.7.8c.1-.4-.2-.8-.6-.8H4.9c-.4 0-.6.2-.7.5l-1.8 10c-.1.6.3 1.1.9 1.1zm6.9 0c.4 0 .8-.3.9-.7L13.6.8c.1-.4-.2-.8-.6-.8h-1.2c-.3 0-.6.2-.6.5l-1.8 10c-.2.6.2 1.1.8 1.1z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/quote.svg
// module id = 313
// module chunks = 1